import * as Sentry from '@sentry/browser';
import { checkAdBlock } from 'adblock-checker'

// Self-executing Sentry initialisation
(function initSentryBrowser() {
	// eslint-disable-next-line no-undef
	const config = typeof sentry_config === 'object' ? sentry_config : {};
	const {
		dsn,
		release = '',
		environment = 'prod',
	} = config;

	if (!dsn) return;

	let hasAdBlocker;

	window.addEventListener('DOMContentLoaded', () => {
		checkAdBlock().then(
			(detected) => {
				hasAdBlocker = detected;
			}
		);
	})

	/**
	 * Reports a custom error to Sentry.
	 * @param {unknown} error - The error to report.
	 * @param {Object} [context] - Optional context (metadata).
	 */
	window.captureSentryError = (error, context) => {
		if (error instanceof Error) {
			Sentry.withScope((scope) => {
				if (context) scope.setExtras(context);
				Sentry.captureException(error);
			});
		} else {
			const message =
				typeof error === 'string' ? error : 'Unknown non-error thrown';
			Sentry.captureMessage(message, 'error');
		}
	};

	/**
	 * List of error messages to exclude from Sentry reporting.
	 * @type {string[]}
	 */
	const excludedErrors = [
		'Failed to fetch',
		'Load failed',
		'fbq is not defined',
		"undefined is not an object (evaluating 'window.webkit.messageHandlers[t].postMessage')",
		"TypeError: undefined is not an object (evaluating 'window.webkit.messageHandlers[e].postMessage')",
		"undefined is not an object (evaluating 'window.webkit.messageHandlers')",
	];

	Sentry.init({
		dsn,
		release,
		environment,
		denyUrls: [],
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.thirdPartyErrorFilterIntegration({
				filterKeys: ['guide-dogs-js'],
			}),
		],
		tracesSampleRate: 0.25,
		sampleRate: 1,
		beforeSend (event, hint) {
			event.extra = {
				...(event.extra || {}),
				hasAdBlocker,
			};

			const error = hint?.originalException;
			if (error instanceof Error) {
				const message = error.message || '';
				if (excludedErrors.some((ex) => message.includes(ex))) {
					return null; // prevent sending
				}
			}
			return event;
		},
	});
})();
